<template>
  <section class="section pt-1 bg-white">
    <div class="container">
      <h1 class="mb-4">{{ $t("help.platform.risk.text") }}</h1>

      <div role="tablist">
        <b-card no-body class=" shadow-none mb-3">
          <b-card-body>
            <p class="mb-3">
              {{ $t("help.platform.risk.line-1") }}
            </p>

            <p class="mt-3 mb-3">{{ $t("help.platform.risk.line-2") }}</p>
            <p class="mt-3 mb-3">{{ $t("help.platform.risk.line-3") }}</p>
            <p class="mt-3 mb-3">{{ $t("help.platform.risk.line-4") }}</p>
          </b-card-body>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1' ? 'founded' : ''" v-b-toggle.col1>
              <div>{{ $t("help.platform.risk.new.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col1" :visible="col == 'col1'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-0">
                {{ $t("help.platform.risk.new.line-1") }}
              </p>

              <img src="@/assets/images/help/new-risk-button.png" class="image" />

              <p class="mt-3 mb-3">
                {{ $t("help.platform.risk.new.line-2") }}
              </p>
              <img src="@/assets/images/help/risk-form.png" class="image" />

              <p class="mt-3 mb-3">
                <u> {{ $t("help.platform.risk.new.line-3") }}</u>
              </p>

              <p>
                <strong>{{ $t("help.platform.risk.new.line-4") }}</strong
                >:{{ $t("help.platform.risk.new.line-5") }}
              </p>
              <p>
                <strong>{{ $t("help.platform.risk.new.line-6") }}</strong
                >:{{ $t("help.platform.risk.new.line-7") }}
              </p>
              <p>
                <strong>{{ $t("help.platform.risk.new.line-8") }}</strong
                >:{{ $t("help.platform.risk.new.line-9") }}
              </p>
              <p>
                <strong>{{ $t("help.platform.risk.new.line-10") }}</strong
                >:{{ $t("help.platform.risk.new.line-11") }}
              </p>
              <p>
                <strong>{{ $t("help.platform.risk.new.line-12") }}</strong
                >:{{ $t("help.platform.risk.new.line-13") }}
              </p>
              <p>
                <strong>{{ $t("help.platform.risk.new.line-14") }}</strong
                >:{{ $t("help.platform.risk.new.line-15") }}
              </p>
              <p class="mb-3">
                <strong>{{ $t("help.platform.risk.new.line-16") }}</strong
                >:{{ $t("help.platform.risk.new.line-17") }}
              </p>

              <img src="@/assets/images/help/risk-asset-group.png" class="image" />

              <p class="mt-3 mb-3">
                {{ $t("help.platform.risk.new.line-18") }}
              </p>
              <p class="mb-3">
                <strong>{{ $t("help.platform.risk.new.line-19") }}</strong
                >:{{ $t("help.platform.risk.new.line-20") }}
              </p>
              <p class="mb-3">
                <strong>{{ $t("help.platform.risk.new.line-21") }}</strong
                >:{{ $t("help.platform.risk.new.line-22") }}
              </p>
              <p class="mt-3 mb-3">
                {{ $t("help.platform.risk.new.line-23") }}
              </p>
              <img src="@/assets/images/help/new-asset-group.png" class="image" />
              <p class="mt-3 mb-3">
                {{ $t("help.platform.risk.new.line-24") }}
              </p>
              <img src="@/assets/images/help/risk-calculate.png" class="image" />
              <p class="mt-3 mb-3">
                {{ $t("help.platform.risk.new.line-25") }}
              </p>

              <ul>
                <li>
                  <p class="mt-3 mb-3">
                    {{ $t("help.platform.risk.new.line-26") }}
                  </p>
                </li>
              </ul>
              <p class="mt-3 mb-3">
                {{ $t("help.platform.risk.new.line-27") }}
              </p>

              <ul>
                <li>
                  <p class="mt-3 mb-3">
                    {{ $t("help.platform.risk.new.line-28") }}
                  </p>
                </li>
              </ul>
              <p class="mt-3 mb-3">
                {{ $t("help.platform.risk.new.line-29") }}
              </p>
              <p class="mt-3 mb-3">
                {{ $t("help.platform.risk.new.line-30") }}
              </p>
              <p class="mt-3 mb-3">
                {{ $t("help.platform.risk.new.line-31") }}
              </p>
              <p class="mt-3 mb-3">
                {{ $t("help.platform.risk.new.line-32") }}
              </p>

              <p class="mb-3">
                <strong>{{ $t("help.platform.risk.new.line-33") }}</strong
                >{{ $t("help.platform.risk.new.line-34") }} <strong>{{ $t("help.platform.risk.new.line-35") }}</strong
                >{{ $t("help.platform.risk.new.line-36") }}
              </p>

              <p class="mb-3">
                <strong>{{ $t("help.platform.risk.new.line-37") }}</strong
                >:{{ $t("help.platform.risk.new.line-38") }}
              </p>
              <p class="mb-3">
                <strong>{{ $t("help.platform.risk.new.line-39") }}:</strong>:{{ $t("help.platform.risk.new.line-40") }}
              </p>
              <p class="mt-3 mb-3">
                {{ $t("help.platform.risk.new.line-41") }}
              </p>
              <ul>
                <li>
                  <p class="mt-3 mb-3">{{ $t("help.platform.risk.new.line-42") }}</p>
                </li>
                <li>
                  <p class="mt-3 mb-3">{{ $t("help.platform.risk.new.line-43") }}</p>
                </li>
                <li>
                  <p class="mt-3 mb-3">{{ $t("help.platform.risk.new.line-44") }}</p>
                </li>
              </ul>

              <p class="mt-3 mb-3">{{ $t("help.platform.risk.new.line-45") }}</p>
              <p class="mt-3 mb-3">{{ $t("help.platform.risk.new.line-46") }}</p>
              <p class="mt-3 mb-3">{{ $t("help.platform.risk.new.line-47") }}</p>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col2' ? 'founded' : ''" v-b-toggle.col2>
              <div>{{ $t("help.platform.risk.assessment.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col2" :visible="col == 'col2'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.risk.assessment.line-1") }}
              </p>
              <p class="mt-3">{{ $t("help.platform.risk.assessment.line-2") }}</p>

              <!-- <h5 class="mt-5">{{$t("help.organization.create.sample-screen")}}</h5> -->
              <img src="@/assets/images/help/assessment-risk.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.risk.assessment.line-3") }}</p>
              <p class="mt-3 mb-3">{{ $t("help.platform.risk.assessment.line-4") }}</p>
              <img src="@/assets/images/help/risk-analysis.png" class="image" />
              <p class="mt-3 mb-3" v-html="$t('help.platform.risk.assessment.line-5')"></p>
              <p class="mt-3 mb-3" v-html="$t('help.platform.risk.assessment.line-6')"></p>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col3' ? 'founded' : ''" v-b-toggle.col3>
              <div>{{ $t("help.platform.risk.prevent.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col3" :visible="col == 'col3'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.risk.prevent.line-1") }}
              </p>
              <p class="mb-3">
                {{ $t("help.platform.risk.prevent.line-2") }}
              </p>
              <img src="@/assets/images/help/risk-related-policy.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.risk.prevent.line-3") }}</p>
              <p class="mt-3 mb-3">{{ $t("help.platform.risk.prevent.line-4") }}</p>
              <p class="mt-3 mb-3">{{ $t("help.platform.risk.prevent.line-5") }}</p>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col4' ? 'founded' : ''" v-b-toggle.col4>
              <div>{{ $t("help.platform.risk.approval.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col4" :visible="col == 'col4'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.risk.approval.line-1") }}
              </p>
              <img src="@/assets/images/help/risk-send-approval.png" class="image" />

              <p class="mb-3">
                {{ $t("help.platform.risk.approval.line-2") }}
              </p>

              <img src="@/assets/images/help/risk-waiting-approval.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.risk.approval.line-3") }}</p>
              <img src="@/assets/images/help/pending-approval-risk.png" class="image" />

              <p class="mt-3 mb-3">{{ $t("help.platform.risk.approval.line-4") }}</p>
              <p class="mt-3 mb-3">{{ $t("help.platform.risk.approval.line-5") }}</p>

              <img src="@/assets/images/help/risk-approve.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.risk.approval.line-6") }}</p>
              <img src="@/assets/images/help/approved-risk.png" class="image" />
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col5' ? 'founded' : ''" v-b-toggle.col5>
              <div>{{ $t("help.platform.risk.inactive.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col5" :visible="col == 'col5'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.risk.inactive.line-1") }}
              </p>
              <img src="@/assets/images/help/inactive-risk.png" class="image" />
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col6' ? 'founded' : ''" v-b-toggle.col6>
              <div>{{ $t("help.platform.risk.review.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col6" :visible="col == 'col6'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.risk.review.line-1") }}
              </p>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col7' ? 'founded' : ''" v-b-toggle.col7>
              <div>{{ $t("help.platform.risk.history.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col7" :visible="col == 'col7'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.risk.history.line-1") }}
              </p>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col8' ? 'founded' : ''" v-b-toggle.col8>
              <div>{{ $t("help.platform.risk.report.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col8" :visible="col == 'col8'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.risk.report.line-1") }}
              </p>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      col: "col1",
    };
  },
  mounted() {
    setTimeout(() => {
      const { col } = this.$route.query;
      this.col = col;
      window.scrollTo({ top: 700, behavior: "smooth" });
    }, 500);
  },
};
</script>

<style scoped>
.founded {
  background: yellow !important;
}
.image {
  display: block;
  max-width: 100%;
}
</style>
